module.exports = __webpack_public_path__ + "media/logos/press-logo-investors-2b70f479.png";